module.exports = __webpack_public_path__ + "img/happybirthday.f55ca9cb.png";